import React, {useState} from "react";
import cn from "classnames";
import * as styles from "./HeaderMainMenu.module.scss";

import {LogoTextPart} from "../LogoTextPart";
import HeaderMenuItem from "./HeaderMenuItem/HeaderMenuItem";
import {FooterMenu} from "../../Footer/FooterMenu/FooterMenu";
import SolutionsMenuDropdown from "../HeaderMenuDropdown/SolutionsMenuDropdown";
import PlatformMenuDropdown from "../HeaderMenuDropdown/PlatformMenuDropdown";
import SupportMenuDropdown from "../HeaderMenuDropdown/SupportMenuDropdown";


function HeaderMainMenu() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleMobileMenuToggle = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const menuButtons = (
    <div className={styles.menuBtnPart}>
      <div className={cn(styles.buttonWrap, styles.gapFix)}>
        <a href={"https://fibery.io/login"} className={styles.loginButton}>
          Log in
        </a>
      </div>

      <div className={cn(styles.buttonWrap)}>
        <a href={"https://fibery.io/sign-up"} className={styles.signupButton}>
          Get started
        </a>
      </div>
    </div>
  );

  return (
    <div className={cn(styles.root, mobileMenuOpen && styles.mobileMenuOpen)}>
      <div className={styles.menuBodyWrap}>
        <nav className={styles.menuList}>
          <a href="https://fibery.io/" className={styles.logo}>
            <LogoTextPart />
          </a>

          <div className={styles.headerDivider} />

          <HeaderMenuItem name={"Solutions"} mobileView={"hidden"}>
            <SolutionsMenuDropdown />
          </HeaderMenuItem>
          <HeaderMenuItem name={"Platform"} mobileView={"hidden"}>
            <PlatformMenuDropdown />
          </HeaderMenuItem>
          <HeaderMenuItem name={"Support"} mobileView={"hidden"}>
            <SupportMenuDropdown />
          </HeaderMenuItem>
          <HeaderMenuItem name={"Pricing"} href={"/pricing"} mobileView={"hidden"} />
        </nav>
        <div className={styles.menuExpander}></div>

        <nav className={cn(styles.menuList, styles.desktopButtonsWrap)}>{menuButtons}</nav>

        <div className={styles.sandwichBtn} onClick={handleMobileMenuToggle} />
      </div>

      <div className={styles.mobileMenu}>
        <div className={styles.mobileButtonsWrap}>{menuButtons}</div>
        <div className={styles.mobileMenuWrap}>
          <FooterMenu />
        </div>
      </div>
    </div>
  );
}

export default HeaderMainMenu;
